<template>
  <section class="d-grid gap-4">
    <header>
      <h2 class="h4 mb-1">Mantenimiento del sistema</h2>
      <p class="text-muted mb-0">
        Este módulo centraliza configuraciones operativas y fiscales del POS.
      </p>
    </header>

    <div class="row g-3">
      <div v-if="canViewOperativo" class="col-md-4" data-test="card-operativo">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Operativo</h3>
            <p class="text-muted small mb-3">Configuración local de impresión, inventario y parámetros operativos.</p>
            <router-link class="btn btn-dark btn-sm" :to="{ name: 'MaintenanceOperational' }">Abrir</router-link>
          </div>
        </div>
      </div>
      <!--
        Balanzas SE OCULTA (D-R6, patrón de D24): es la integración con balanza
        de despensa —formatos de código PLU por peso— y un colegio no pesa
        uniformes. La ruta `/mantenimiento/balanzas` y su pantalla siguen
        vivas y gateadas por `ver_depositos`; lo que se saca es la puerta.
      -->
      <div v-if="canViewFiscal" class="col-md-4" data-test="card-fiscal">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Fiscal</h3>
            <p class="text-muted small mb-3">Establecimientos, puntos de expedición, timbrados y series activas.</p>
            <div class="d-flex gap-2 flex-wrap">
              <router-link class="btn btn-dark btn-sm" :to="{ name: 'MaintenanceFiscalDashboard' }">Abrir</router-link>
              <router-link class="btn btn-outline-dark btn-sm" :to="{ name: 'MaintenanceFiscalSeries' }">Ver series</router-link>
            </div>
          </div>
        </div>
      </div>
      <div v-if="canViewUsers || canManageCashboxes" class="col-md-4" data-test="card-usuarios-cajas">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Usuarios y Cajas</h3>
            <p class="text-muted small mb-3">Asignación de sucursales por usuario y configuración de cajas por establecimiento.</p>
            <div class="d-flex gap-2 flex-wrap">
              <router-link v-if="canViewUsers" class="btn btn-dark btn-sm" :to="{ name: 'UserManagement' }">Usuarios</router-link>
              <router-link v-if="canManageCashboxes" class="btn btn-outline-dark btn-sm" :to="{ name: 'MaintenanceCashboxes' }">Cajas</router-link>
            </div>
          </div>
        </div>
      </div>
      <!--
        La tarjeta puente a Ecommerce se retira junto con la sección del menú
        (D-R6): no hay storefront en este producto. La ruta sigue viva.
      -->
      <div v-if="canManageJobs" class="col-md-4" data-test="card-jobs">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Jobs programados</h3>
            <p class="text-muted small mb-3">Backfill nocturno de imágenes y resumen diario de ventas/caja por email.</p>
            <router-link class="btn btn-dark btn-sm" :to="{ name: 'MaintenanceJobs' }">Abrir</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { hasPermission } from '@/services/authSessionService'

// A-12 · Estas tres tarjetas no tenían `v-if` ninguno: quien entraba a la
// pantalla las veía todas. Medido: `ayudante_deposito` —once permisos, el rol
// más acotado— llegaba acá por su `ver_depositos` y veía la tarjeta Fiscal.
// Los permisos son los mismos que gatean las rutas de destino, para que no se
// ofrezca un botón que el guard va a rechazar.
const canViewOperativo = computed(() => hasPermission('ver_depositos'))
const canViewFiscal = computed(() => hasPermission('ver_facturacion_electronica'))
const canViewUsers = computed(() => hasPermission('ver_usuarios'))
const canManageCashboxes = computed(() => hasPermission('actualizar_deposito'))
const canManageJobs = computed(() => hasPermission('gestionar_jobs'))
</script>
